import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=18224d24&"
var script = {}
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=18224d24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports